<template>
    <svg
        class="w-6 h-6"
        fill="none"
        stroke-width="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="12"
            cy="12"
            r="8"
            fill="#10b981"
            stroke="#059669"
        />
    </svg>
</template>
